import { CommonModule } from '@angular/common';
import {
  Component,
  effect,
  ElementRef,
  input,
  model,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'table-datatable-search',
  templateUrl: './datatable-search.component.html',
  styleUrls: ['./datatable-search.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatBadgeModule,
  ],
})
export class DatatableSearchComponent {
  initialShowSearch = input(false);
  defaultSearch = input<string>();

  showSearch = signal(this.initialShowSearch());

  setInitialShowEffect = effect(() => this.showSearch.set(this.initialShowSearch()));

  search = model(this.defaultSearch() ?? '');
  searchInput = viewChild<ElementRef<HTMLInputElement>>('searchInput');

  searchFieldEdit = output<string>();

  private hideInitialIfEmpty = true;

  debounceEffect = effect((onCleanup) => {
    const currentSearch = this.search();
    const timer = setTimeout(() => {
      const processedSearch = this.convertToCommaSeparatedNumericString(currentSearch);
      if (this.hideInitialIfEmpty && !processedSearch) return;
      this.hideInitialIfEmpty = false;
      this.searchFieldEdit.emit(processedSearch.trim());
    }, 300);
    onCleanup(() => clearTimeout(timer));
  });

  onClick() {
    this.showSearch.update((value) => !value);
    if (this.showSearch()) setTimeout(() => this.searchInput()?.nativeElement.focus(), 0);
  }

  onReset() {
    this.search.set('');
  }

  private convertToCommaSeparatedNumericString(wordSeparatedNumericSearchInput: string) {
    const isNumericSearch =
      !/[BC]|[E-M]|[O-T]|[V-Z]|ß+/i.test(wordSeparatedNumericSearchInput) &&
      /\d/.test(wordSeparatedNumericSearchInput);
    return isNumericSearch
      ? wordSeparatedNumericSearchInput.replace(/and|und|;|\s/gi, ',').replace(/,+/g, ',')
      : wordSeparatedNumericSearchInput;
  }
}
